module.exports = __webpack_public_path__ + "static/media/three.380c7549.svg";